import React, { useEffect, useState } from 'react';

import { useNEFISteps } from 'context/NEFIStepsContext';
import PropTypes from 'prop-types';

import { FormActionButtons } from 'components/FormHelper/FormActionButtons';
import {
  NEFI_CURRENT_TEST_SUITE,
  shouldFillNEFITestData,
} from 'components/NEFIForm/NEFITestdata/NEFITestSetup';

import { NE_ACTIVE_STEP } from 'global/constants';

import { NEFIFormPage } from './NEFIFormPage';

import './NEFIStepForm.sass';

export const NEFIStepForm = ({ energyAgreementLink, gasAgreementLink }) => {
  const { activeStep, setActiveStep, setSubmittedValuesWithStep } = useNEFISteps();
  const [buttonErrorMessage, setButtonErrorMessage] = useState('');

  useEffect(() => {
    if (shouldFillNEFITestData) {
      setSubmittedValuesWithStep(NE_ACTIVE_STEP.EMAIL_INPUT, NEFI_CURRENT_TEST_SUITE.step0);
      setSubmittedValuesWithStep(NE_ACTIVE_STEP.BRANCH_SELECTION, NEFI_CURRENT_TEST_SUITE.step1);
    }
  }, []);

  if (activeStep !== NE_ACTIVE_STEP.FORM) return null;

  const onBack = () => {
    setActiveStep(NE_ACTIVE_STEP.BRANCH_SELECTION);
  };

  const onSubmit = () => {
    setActiveStep(NE_ACTIVE_STEP.FORM_UPLOAD);
  };

  return (
    <>
      <div className="nefi-step-form">
        <NEFIFormPage
          energyAgreementLink={energyAgreementLink}
          gasAgreementLink={gasAgreementLink}
          setButtonErrorMessage={setButtonErrorMessage}
        />
      </div>
      <div className="nefi-form__action-buttons">
        <FormActionButtons
          hasErrors={Boolean(buttonErrorMessage)}
          titleLeft="Zurück"
          titleRight={activeStep === NE_ACTIVE_STEP.FORM_UPLOAD ? 'Antrag einreichen' : 'Weiter'}
          onClickLeft={onBack}
          onClickRight={onSubmit}
          errorMessage={buttonErrorMessage}
        />
      </div>
    </>
  );
};

NEFIStepForm.propTypes = {
  energyAgreementLink: PropTypes.string,
  gasAgreementLink: PropTypes.string,
};

NEFIStepForm.defaultProps = {
  energyAgreementLink: '',
  gasAgreementLink: '',
};
